import React from 'react';
import { connect } from 'react-redux';

import SvgComponent from '../../../SvgComponent';
import { STATIC_ROOT } from '../../../../constants';
import { PAYMENT_DELAY } from '../../../../constants/payment';
import { InfoAccountComponent } from '../InfoAccountComponent';
import PaymentRequestFormComponent from './PaymentRequestFormComponent';
import { toDate, nowTimestampPlusDays } from '../../../../utils/dateUtils';
import { MOMENTJS_DATE_FORMAT_STANDARD } from '../../../../constants/moment';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import './PaymentRequest.scss';

class PaymentRequestAreaComponent extends React.Component {
    render() {
        const { i18n } = this.props;

        const estimatedDatePayment = toDate(
            nowTimestampPlusDays(PAYMENT_DELAY),
            MOMENTJS_DATE_FORMAT_STANDARD
        );

        return (
            <div id="formDemandePaiement-wrap">
                <InfoAccountComponent>
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18n.PAYMENT_DELAY,
                            `<span class="bold">${estimatedDatePayment}</span>`
                        )}
                    </p>
                </InfoAccountComponent>
                <h3>{i18n.PAYMENT_TITLE}</h3>
                <div className="info">
                    <span className="p-info">
                        <SvgComponent
                            src={`${STATIC_ROOT}/compte/info.svg`}
                            width="21"
                            height="20"
                        />
                    </span>
                    {i18n.PAYMENT_LEGEND}
                </div>
                <PaymentRequestFormComponent />
                <hr />
            </div>
        );
    }
}

const mapStoreToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
};

export default connect(mapStoreToProps)(PaymentRequestAreaComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestAreaComponent.js